import React from "react";
import styled from "styled-components";
import { Theme } from "../../common/themes/theme";

const { color, font } = Theme;

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${color.background.light};
  font-family: ${font.fontFamily.sans[0]}, sans-serif;
`;

const Content = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const LogoMark = styled.div`
  width: 28px;
  height: 28px;
  background: ${color.text.primary};
  clip-path: polygon(0 0, 100% 0, 100% 70%, 70% 100%, 0 100%);
  margin: 0 auto 8px;
`;

const Title = styled.h1`
  font-family: ${font.fontFamily.heading[0]}, sans-serif;
  font-size: 48px;
  font-weight: ${font.fontWeight.bold};
  text-transform: uppercase;
  color: ${color.text.heading};
  letter-spacing: -0.01em;
  line-height: 1.05;
  margin: 0;

  span {
    color: ${color.text.primary};
  }
`;

const Sub = styled.p`
  font-size: ${font.fontSize.base};
  color: ${color.text.secondary};
  margin: 0;
  letter-spacing: 0.02em;
`;

function ProjectPage() {
  return (
    <Wrapper>
      <Content>
        <LogoMark />
        <Title>
          Projects <span>Coming Soon</span>
        </Title>
        <Sub>We're working on something great. Check back later.</Sub>
      </Content>
    </Wrapper>
  );
}

export default ProjectPage;